import React, { useState, useEffect } from 'react';

import StatusBadge from './StatusBadge';

function StatusBadgeContainer({ retrospective }) {
  const [statusBadgeProgress] = useState({
    notStarted: { color: 'badgeNStarted', text: 'not started' },
    inProgress: { color: 'badgeInProgress', text: 'in progress' },
    done: { color: 'badgeDone', text: 'done' },
    error: { color: 'danger', text: 'unknown' },
  });
  const [color, setColor] = useState('');
  const [text, setText] = useState('');

  const [stages] = useState([
    'TEAM MOOD',
    'THINK',
    'GROUP',
    'VOTE',
    'DISCUSS',
    'SUMMARY',
  ]);

  const { cardsCount, stage, moodStarted, teamMoodQuestions } = retrospective;

  useEffect(() => {
    const checkError = () => {
      const initialStages = ['TEAM MOOD, THINK', 'GROUP'];
      if (cardsCount < 0) return true;
      if (typeof cardsCount !== 'number' && cardsCount !== null) return true;
      if (typeof stage !== 'string') return true;
      if (cardsCount === null && !initialStages.includes(stage)) return true;
      return !stages.includes(stage);
    };
    const thinkStarted = () =>
      !(!moodStarted && cardsCount === 0 && stage === 'THINK');
    const teamMoodStarted = () =>
      !(!moodStarted && teamMoodQuestions?.length > 0 && stage === 'TEAM MOOD');
    const isSummary = () => cardsCount >= 1 && stage === 'SUMMARY';
    const getStatusBadge = () =>
      // eslint-disable-next-line no-nested-ternary
      checkError()
        ? statusBadgeProgress.error
        : // eslint-disable-next-line no-nested-ternary
        !thinkStarted() || !teamMoodStarted()
        ? statusBadgeProgress.notStarted
        : isSummary()
        ? statusBadgeProgress.done
        : statusBadgeProgress.inProgress;

    const status = getStatusBadge();
    setColor(status.color);
    setText(status.text);
  }, [
    cardsCount,
    moodStarted,
    stage,
    stages,
    statusBadgeProgress.done,
    statusBadgeProgress.error,
    statusBadgeProgress.inProgress,
    statusBadgeProgress.notStarted,
    teamMoodQuestions?.length,
  ]);
  return <StatusBadge color={color} text={text} />;
}

export default StatusBadgeContainer;
